import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/GitLab'

const GitLab: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'GitLab DevOps デプロイ バージョン管理 CI/CD'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/gitlab/'}
        title="Gitlab | サービス | Aitria（アイトリア）"
        description="GitLab導入支援で、バージョン管理からCI/CD、デプロイまでDevOps全体を統合管理できます。生産性向上と効率化を実現します。"
      />
      <Template />
    </>
  )
}

export default GitLab
